import type { UUID } from '@cobliteam/common-types';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { Configuration, IRequest } from '../../request/Types';

export class FootageRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public retryFootageRequest = async (mediaId: UUID): Promise<number> => {
    const requestData: IRequest = {
      endpoint: `/cameras/media/${mediaId}/retry`,
      method: HttpMethod.PUT,
    };

    const { status } = await this.requester.request(requestData);

    return status;
  };
}
